import React from "react";
import "./Partners.css";

export default function Partners() {
  const logos = [
    "/images/logos/munucipality.png",
    "/images/logos/culture-ministry.png",
    "/images/logos/enghelab-farhangi.png",
    "/images/logos/amirkabir.png",
    "/images/logos/oil-uni.jpg",
    "/images/logos/reza-abbasi.png",
    "/images/logos/shahnameh-news.jpg",
    "/images/logos/bonyad-ferdowsi.jpg",
    "/images/logos/toospedia.jpg",
    "/images/logos/afra.png",

  ];

  return (
    <section className="partners-section">
      <h2 className="partners-title">افتخار همکاری با سازمان‌های:</h2>
      <div className="partners-row">
        {logos.map((logo, i) => (
          <div className="partner-logo-wrapper" key={i}>
            <img src={logo} alt={`partner-${i}`} className="partner-logo" />
          </div>
        ))}
      </div>
    </section>
  );
}
